import React from 'react';
import { getAssets } from 'themes/assets';
import { _t } from 'utils';

export default () => {
  const assets = getAssets();

  return (
    <div className="screen-404">
      <h3>{_t('Page not found')}</h3>
      <p>
        {_t('We are sorry but the page you are looking for is unavailable, was renamed or no longer exists.')}
        {' '}
        {_t('Also, please be sure that you are using the correct URL.')}
      </p>
      <img src={assets.Image404} alt="404" />
    </div>
  );
};
